/**
 * Portal Admin
 * Thehose APIs are only available for portal administrators 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: portal-dev@intersystems.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The response schema to backup API endpoint when eventtype is restore. This output is the return of boto3.backup.start_restore_job.
 */
export interface BackupCreateSnapshotRestore { 
    RestoreJobId?: string;
}

